export enum StockPartRequestEventsEnum {
  Note = 'Note',
  PartRequestLineFieldUpdateOrAddingValue = 'PartRequestLineFieldUpdateOrAddingValue',
  PartRequestLineDelete = 'PartRequestLineDelete',
  PartRequestLineLinkPurchaseOrder = 'PartRequestLineLinkPurchaseOrder',
  PartRequestLineUnlinkPurchaseOrder = 'PartRequestLineUnlinkPurchaseOrder',
}
